import "./Cscenter.css";
import { useMembership } from "../../hooks/MembershipProvider/MembershipProvider";
import { useEffect, useState } from "react";
import List from "./List";
import Form from "./Form";
import View from "./View";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import useAndroidBridge from "../../hooks/useAndroidBridge";
const Cscenter = () => {
  const { user, isAuthenticated, logout, refreshUser } = useMembership();
  const [userInfo, setUserInfo] = useState<any>({});
  const [actType, setActType] = useState(`list`);
  const navigate = useNavigate();
  const loaction = useLocation();
  const [search] = useSearchParams();
  const { isEmbed } = useMembership();
  const { sendToAndroid } = useAndroidBridge();
  // actType 분류 - list:리스트 화면, view:상세화면, add:작성화면, mod:수정화면

  const onHandleActType = (res: any) => {
    setActType(res);
    navigate(`/cs_center?act_type=${res}`);
  };

  const getReady = async () => {
    let query = search.get("act_type");
    console.log(query);
    if (!query) {
      setActType("list");
    }
    if (query) {
      setActType(query);
    }
  };

  // console.log(userInfo);

  useEffect(() => {
    setUserInfo(user);
  }, [search]);
  useEffect(() => {
    getReady();
  }, [search]);

  // console.log(isAuthenticated);
  console.log(loaction);
  // console.log(search);
  // console.log(actType);

  return (
    <>
      {!isAuthenticated && (
        <div className={`content_wrap cs_center`}>
          <div className={`section_wrap`}>
            <div className={`sec`}>로그인시 확인 가능합니다.</div>
          </div>
        </div>
      )}
      {isEmbed() && (
        <div className={`mobile_app_header`}>
          <button
            onClick={() => sendToAndroid("go-to-page", "")}
            className={`btn btn_back`}
          ></button>
          {/* <p className={`mobile_app_header_text`}>1:1문의</p> */}
        </div>
      )}
      {isAuthenticated && (
        <div className={`content_wrap cs_center`}>
          <div className={`section_wrap sec_wrap_1`}>
            <div className={`sec sec_1`}>
              <h1 className={`h1`}>1:1문의</h1>
            </div>
          </div>
          {actType === `list` && (
            <List
              userInfo={userInfo}
              actType={actType}
              actChage={(res: any) => {
                onHandleActType(res);
              }}
            />
          )}
          {(actType === `add` || actType === "edit") && (
            <Form
              userInfo={userInfo}
              actType={actType}
              actChage={(res: any) => {}}
            />
          )}
          {actType === "view" && (
            <View
              userInfo={userInfo}
              actType={actType}
              actChage={(res: any) => {
                onHandleActType(res);
              }}
            />
          )}
        </div>
      )}
    </>
  );
};
export default Cscenter;
